<template>
  <div class="row mt-0 mb-0">
    <div class="col-lg-6 col-md-8 col-sm-10 m-auto card-container">
      <div class="card mt-md-3 mb-md-3 bg-white shadow">
        <div class="card-header mt-1 mb-2" :style="'height:' + 36 + 'px'">
          <div class="row ">
            <div class="col-2 ">
              <div class="avatar avatar">
                <img style="filter: hue-rotate(190deg); -webkit-filter: hue-rotate(190deg); transition: 3s all ease-out;" src="@/assets/static/main/self5.gif" alt="..." class="avatar-img rounded-circle shadow-lg">
              </div>
            </div>
            <div class="col-6 mt-1">
              <span class="h3  ml-2">Emika</span>
              <div class="text-muted ml-2 small">{{ $t("chat.welcome") }} </div>
            </div>
          </div>
        </div>
        <div class="card-body p-lg-4 p-3 h-100" style="overflow-y: auto;">
          <auth-step
            v-if="step === 'auth'"
            :person-data="personData"
            :show-invite="showInvite"
            @updateValues="updatePersonData"
            @setStep="setStep"
          ></auth-step>

          <login-step
            v-if="step === 'login'"
            :person-data="personData"
            :show-invite="showInvite"
            @updateValues="updatePersonData"
            @setStep="setStep"
          ></login-step>
          <register-step
            v-if="step === 'signUp'"
            :person-data="personData"
            :show-invite="showInvite"
            @updateValues="updatePersonData"
            @setStep="setStep"
          ></register-step>

          <account-setup-step
            v-if="step === 'accountSetup'"
            :person-data="personData"
            :show-invite="showInvite"
            @updateValues="updatePersonData"
            @setStep="setStep"
          ></account-setup-step>
          <select-workspace-step
            v-if="step === 'selectWorkspace'"
            :person-data="personData"
            :show-invite="showInvite"
            @updateValues="updatePersonData"
            @setStep="setStep"
          ></select-workspace-step>
          <create-company-step
            v-if="step === 'createCompany'"
            @setCompanyName="setCompanyName"
            @setStep="setStep"
          ></create-company-step>
          <join-company-step
            v-if="step === 'joinCompany'"
            :person-data="personData"
            @setStep="setStep"
          ></join-company-step>
          <company-invite-step
            v-if="step === 'companyInvite'"
            :companyName="companyName"
            @setStep="setStep"
          ></company-invite-step>

          <restore-pass-step
            v-if="step === 'restore'"
            :person-data="personData"
            :show-invite="showInvite"
            @updateValues="updatePersonData"
            @setStep="setStep"
          ></restore-pass-step>
          <set-new-pass-step
            v-if="step === 'setNewPassword'"
            :person-data="personData"
            :show-invite="showInvite"
            @updateValues="updatePersonData"
            @setStep="setStep"
          ></set-new-pass-step>

          <email-confirmation-step
            v-if="step === 'emailConfirmation'"
            :person-data="personData"
          ></email-confirmation-step>

          <finish-step
            v-if="step === 'finish'"
          ></finish-step>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ValidateEmailMixin } from '@/components/authPage/mixins/ValidateEmailMixin';
  import { CheckInviteMixin } from '@/components/authPage/mixins/CheckInviteMixin';

  import AuthStep from '../../components/authPage/elements/AuthStep';

  import LoginStep from '../../components/authPage/elements/LoginStep';
  import RegisterStep from '../../components/authPage/elements/RegisterStep';

  import AccountSetupStep from '../../components/authPage/elements/AccountSetupStep';
  import SelectWorkspaceStep from '../../components/authPage/elements/SelectWorkspaceStep';
  import CreateCompanyStep from '../../components/authPage/elements/CreateCompanyStep';
  import JoinCompanyStep from '../../components/authPage/elements/JoinCompanyStep';
  import CompanyInviteStep from '../../components/authPage/elements/CompanyInviteStep';

  import RestorePassStep from '../../components/authPage/elements/RestorePassStep';
  import SetNewPassStep from '../../components/authPage/elements/SetNewPassStep';

  import EmailConfirmationStep from '../../components/authPage/elements/EmailConfirmationStep';

  import FinishStep from '../../components/authPage/elements/FinishStep';

  import { checkEmail, fetchShowInvite, checkRestoreCode } from '@/api/authApi';

  export default {
    name: 'AuthPage',
    mixins: [ValidateEmailMixin, CheckInviteMixin],
    data () {
      return {
        step: 'auth',
        personData: {
          email: '',
          password: '',
          firstName: '',
          lastName: '',
          restoreCode: '',
          invitedMe: [],
        },
        companyName: '',
        showInvite: null,
      };
    },
    methods: {
      setStep: function (newStep) {
        this.step = newStep;
      },
      setCompanyName: function (newCompanyName) {
        this.companyName = newCompanyName;
      },
      updatePersonData: function (newData) {
        this.personData = newData;
      },
      checkEmailRegistered: async function () {
        if (this.validateEmail(this.personData.email)) {
          const isRegistered = await checkEmail(this.personData.email);
          this.step = isRegistered ? 'login' : 'signUp';
        } else {
          this.$noty.show('It looks like email is not a valid one');
        }
      },
    },
    watch: {
      step: function (newStep) {
        if (newStep === 'login' || newStep === 'signUp' || newStep === 'selectWorkspace') {
          this.checkInvite();
        }
      },
    },
    async mounted () {
      if (this.$route.query.email) {
        if (this.validateEmail(this.$route.query.email)) {
          this.email = this.$route.query.email;
          await this.checkEmailRegistered();
        }
      }

      if (this.$route.query.invite_code) {
        this.showInvite = await fetchShowInvite(this.$route.query.invite_code);
        this.personData.email = this.showInvite.email;
        this.personData.firstName = this.showInvite.first_name;
        this.personData.lastName = this.showInvite.last_name;
        await this.checkEmailRegistered();
      }

      if (this.$route.query.restore_code) {
        const ok = checkRestoreCode(this.$route.query.restore_code);
        if (ok) {
          this.personData.restoreCode = this.$route.query.restore_code;
          this.setStep('setNewPassword');
        } else {
          self.$noty.error('Restore code is not valid. Please, request it one more time or contact support.');
        }
      }
    },
    components: {
      AuthStep,
      LoginStep,
      RegisterStep,

      AccountSetupStep,
      SelectWorkspaceStep,
      CreateCompanyStep,
      JoinCompanyStep,
      CompanyInviteStep,

      RestorePassStep,
      SetNewPassStep,

      EmailConfirmationStep,

      FinishStep,
    },
  };
</script>

<style scoped>

  .card-container {
    min-width: 300px;
    max-width: 600px;
  }

  .card {
    height: 97vh;
  }

</style>
